import './index.less';

import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  TextLabel,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';

const ClassicScheduleReportDetailModal = (props: {
  onClose: (close: any) => void;
  data: any;
}) => {
  const { t } = useTranslation();
  const labels: string[] = [
    'name',
    'frequency',
    'startTime',
    'startDay',
    'timeZone',
    'emailEnable',
    'recipients',
  ];
  if (!props.data) return <></>;
  return (
    <Modal
      closeOnEsc
      closeOnOutsideClick
      isClosable
      isOpen={!!props.data}
      onClose={() => props.onClose(null)}
      size="md"
    >
      <ModalOverlay />
      <ModalContent className="previewContent">
        <ModalHeader>
          <Text className="title">
            {t('reportCommon.classicScheduleReportDetail.title')}
          </Text>
        </ModalHeader>
        <ModalBody>
          {labels.map((label) => {
            if (label === 'startDay' && props.data['frequency'] === 'daily') {
              return;
            }
            return (
              <div className="item" key={`preview-${label}`}>
                <TextLabel className="label">
                  {t(`reportCommon.labels.${label}`)}:&nbsp;
                </TextLabel>
                {typeof props.data[label] === 'boolean' ? (
                  <Text>{props.data[label] ? 'True' : 'False'}</Text>
                ) : (
                  <Text>{props.data[label]}</Text>
                )}
              </div>
            );
          })}
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => props.onClose(false)} minWidth="20x">
            {t('reportCommon.buttons.close')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ClassicScheduleReportDetailModal;
